/**
 * GoogleSignIn · v2.6.7 batch J
 *
 * "Continue with Google" button that uses the Emergent-managed Google OAuth
 * proxy. We send the user to `https://auth.emergentagent.com/?redirect=<absolute callback URL>`;
 * the proxy handles the Google consent screen and bounces back to our
 * callback path with `#session_id=...` in the URL fragment, where
 * AuthCallback.jsx exchanges it for a session cookie.
 */
import { Button } from "@/components/ui/button";

const GoogleGlyph = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.92h5.45c-.24 1.4-1.79 4.13-5.45 4.13-3.28 0-5.96-2.72-5.96-6.07s2.68-6.07 5.96-6.07c1.87 0 3.12.8 3.84 1.49l2.62-2.53C16.95 3.6 14.7 2.6 12 2.6 6.86 2.6 2.7 6.77 2.7 11.9s4.16 9.3 9.3 9.3c5.37 0 8.93-3.78 8.93-9.1 0-.61-.07-1.07-.15-1.53H12z"/>
    <path fill="#34A853" d="M3.91 7.22 6.79 9.34c.78-1.55 2.34-2.63 4.21-2.63 1.16 0 2.21.4 3.04 1.18l2.62-2.53C14.85 4.05 13.5 3.5 12 3.5 8.9 3.5 6.21 5.32 4.83 7.92l-.92-.7z"/>
    <path fill="#FBBC05" d="M12 21.2c2.65 0 4.86-.88 6.48-2.39l-3.09-2.4c-.88.6-2.05.95-3.39.95-2.6 0-4.81-1.75-5.6-4.11l-3.05 2.36C4.79 19.18 8.13 21.2 12 21.2z"/>
    <path fill="#4285F4" d="M21 11.9c0-.61-.07-1.07-.15-1.53H12v3.92h5.45c-.18.95-.94 2.36-2.65 3.18l3.09 2.4C19.5 18.34 21 15.5 21 11.9z"/>
  </svg>
);

export default function GoogleSignIn({ redirectPath = "/auth/callback", label = "Continue with Google", testid = "google-signin-btn", className = "" }) {
  const onClick = () => {
    // CRITICAL: redirect target must be an ABSOLUTE URL — the Emergent proxy
    // appends `#session_id=...` to it and follows back here.
    const redirect = `${window.location.origin}${redirectPath}`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <div className={`pb-3 ${className}`}>
      <Button
        type="button"
        data-testid={testid}
        onClick={onClick}
        variant="outline"
        className="w-full h-11 bg-white hover:bg-zinc-100 text-zinc-900 font-semibold border-zinc-300 flex items-center justify-center gap-2 shadow-sm"
      >
        <GoogleGlyph/>
        <span>{label}</span>
      </Button>
      <div className="flex items-center gap-2 mt-3">
        <div className="flex-1 h-px bg-zinc-800"/>
        <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-semibold">or</span>
        <div className="flex-1 h-px bg-zinc-800"/>
      </div>
    </div>
  );
}
